import Components from "../components";

class BrowserStatsComponent extends Components.Base {
  bind() {
    const url = document.location.pathname.replace(
      /projects\/(\d+)\/faults\/(\d+)(.*)?/,
      'projects/$1/faults/$2/browser_stats',
    );
    $.ajax(url, {
      type: 'get',
      dataType: 'html',
      success: response => {
        this.$el.html(response);
      },
    });
  }
}

Components.collection.register({
  selector: '.c-browser-stats',
  klass: BrowserStatsComponent,
});
